import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from 'match-sorter';
import {BotonPDFpequeno} from "../Plantillas/Botones";
import PageLoading from '../PageLoading.js';
import {decimalAdjust, EFECTIVO, ESTADO_CE, ESTADO_VALE, ESTADO_VENTA, POS, MASTER, AMERICAN, OTROS, PAGO_CREDITO, FPAY, YAPE, PLIN, RAPPI, TUNKI} from "../../Global";
import {calcularMovsCaja, getTotalRedondeo} from "../../helpers/utils";
import { handleSavePDF } from '../Caja/printDataCaja.js';

class turnosDetalleList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dataturnosSucursal: {
                turnosSucursal: []
            },
            dataPdf: {
                InfoPDF: []
            },
            data: {
                movCajas: []
            },
            MontoEntradas: 0,
            MontoSalidas: 0,
            loading: false,
            error: null,
            extImg: 'png',
            IdTurnoCaja: 0,
        }
        this.obtenerTurnos = this.obtenerTurnos.bind(this);
        this.printItem = this.printItem.bind(this);
        this.TraerInfoPDF = this.TraerInfoPDF.bind(this);
        this.calcularTotales = this.calcularTotales.bind(this);
        this.getConfiguration = this.getConfiguration.bind(this);
        this.fetchMontosCaja = this.fetchMontosCaja.bind(this);
    }

    componentDidMount() {
        this.obtenerTurnos();
        this.getConfiguration();
    }

    obtenerTurnos = async () => {
        try {
            const response = await fetch(`/api/turnosList/`);
            const data = await response.json();
            this.setState({
                loading: true,
                dataturnosSucursal: data,
                extImg: data.extImg
            })
        } catch (error) {
            this.setState({loading: false, error: error})
        }
    }

    obtenerMovimientos = async (IdTurnoCaja) => {
        try {
            const response = await fetch(`/api/cajas/movimientosPorTurno/${IdTurnoCaja}`);// ${this.state.IdTurno}El idTurno debe ser dinámico, se debe capturar el Idturno ni bien se crea una apertura - Puede ser enviado por props
            const data = await response.json();
            this.setState({
                data: data
            })
            console.log(data)
            await this.getMontosEntradasSalidas();

        } catch (error) {
            this.setState({loading: false, error: error})
        }
    }

    NumeroALetras(num, centavos) {
        var data = {
            numero: num,
            enteros: Math.floor(num),
            centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
            letrasCentavos: "",
        };
        //Revisar en caso no salgan los soles  centimos correctamente: https://www.lawebdelprogramador.com/codigo/JavaScript/5192-Conversor-de-numeros-a-letras.html
        if (centavos == undefined || centavos == false) {
            data.letrasMonedaPlural = "SOLES";
            data.letrasMonedaSingular = "SOL";
        } else {
            data.letrasMonedaPlural = "CENTIMOS";
            data.letrasMonedaSingular = "CENTIMO";
        }

        if (data.centavos > 0)
            data.letrasCentavos = "CON " + this.NumeroALetras(data.centavos, true);

        if (data.enteros == 0)
            return "CERO " + data.letrasMonedaPlural + " " + data.letrasCentavos;
        if (data.enteros == 1)
            return this.Millones(data.enteros) + " " + data.letrasMonedaSingular + " " + data.letrasCentavos;
        else
            return this.Millones(data.enteros) + " " + data.letrasMonedaPlural + " " + data.letrasCentavos;
    }//NumeroALetras()

    Unidades(num) {

        switch (num) {
            case 1:
                return "UN";
            case 2:
                return "DOS";
            case 3:
                return "TRES";
            case 4:
                return "CUATRO";
            case 5:
                return "CINCO";
            case 6:
                return "SEIS";
            case 7:
                return "SIETE";
            case 8:
                return "OCHO";
            case 9:
                return "NUEVE";
        }

        return "";
    }

    Decenas(num) {

        var decena = Math.floor(num / 10);
        var unidad = num - (decena * 10);

        switch (decena) {
            case 1:
                switch (unidad) {
                    case 0:
                        return "DIEZ";
                    case 1:
                        return "ONCE";
                    case 2:
                        return "DOCE";
                    case 3:
                        return "TRECE";
                    case 4:
                        return "CATORCE";
                    case 5:
                        return "QUINCE";
                    default:
                        return "DIECI" + this.Unidades(unidad);
                }
            case 2:
                switch (unidad) {
                    case 0:
                        return "VEINTE";
                    default:
                        return "VEINTI" + this.Unidades(unidad);
                }
            case 3:
                return this.DecenasY("TREINTA", unidad);
            case 4:
                return this.DecenasY("CUARENTA", unidad);
            case 5:
                return this.DecenasY("CINCUENTA", unidad);
            case 6:
                return this.DecenasY("SESENTA", unidad);
            case 7:
                return this.DecenasY("SETENTA", unidad);
            case 8:
                return this.DecenasY("OCHENTA", unidad);
            case 9:
                return this.DecenasY("NOVENTA", unidad);
            case 0:
                return this.Unidades(unidad);
        }
    }//Unidades()

    DecenasY(strSin, numUnidades) {
        if (numUnidades > 0)
            return strSin + " Y " + this.Unidades(numUnidades)

        return strSin;
    }//DecenasY()

    Centenas(num) {

        var centenas = Math.floor(num / 100);
        var decenas = num - (centenas * 100);

        switch (centenas) {
            case 1:
                if (decenas > 0)
                    return "CIENTO " + this.Decenas(decenas);
                return "CIEN";
            case 2:
                return "DOSCIENTOS " + this.Decenas(decenas);
            case 3:
                return "TRESCIENTOS " + this.Decenas(decenas);
            case 4:
                return "CUATROCIENTOS " + this.Decenas(decenas);
            case 5:
                return "QUINIENTOS " + this.Decenas(decenas);
            case 6:
                return "SEISCIENTOS " + this.Decenas(decenas);
            case 7:
                return "SETECIENTOS " + this.Decenas(decenas);
            case 8:
                return "OCHOCIENTOS " + this.Decenas(decenas);
            case 9:
                return "NOVECIENTOS " + this.Decenas(decenas);
        }

        return this.Decenas(decenas);
    }//Centenas()

    Seccion(num, divisor, strSingular, strPlural) {
        var cientos = Math.floor(num / divisor)
        var resto = num - (cientos * divisor)

        var letras = "";

        if (cientos > 0)
            if (cientos > 1)
                letras = this.Centenas(cientos) + " " + strPlural;
            else
                letras = strSingular;

        if (resto > 0)
            letras += "";

        return letras;
    }//Seccion()

    Miles(num) {
        var divisor = 1000;
        var cientos = Math.floor(num / divisor)
        var resto = num - (cientos * divisor)

        var strMiles = this.Seccion(num, divisor, "MIL", "MIL");
        var strCentenas = this.Centenas(resto);

        if (strMiles == "")
            return strCentenas;

        return strMiles + " " + strCentenas;

        //return Seccion(num, divisor, "UN MIL", "MIL") + " " + Centenas(resto);
    }//Miles()

    Millones(num) {
        var divisor = 1000000;
        var cientos = Math.floor(num / divisor)
        var resto = num - (cientos * divisor)

        var strMillones = this.Seccion(num, divisor, "UN MILLON", "MILLONES");
        var strMiles = this.Miles(resto);

        if (strMillones == "")
            return strMiles;

        return strMillones + " " + strMiles;
    }

    TraerInfoPDF = async (IdTurnoCaja) => {
        try {
            const response = await fetch(`/api/cajas/cierreTurno/InfoPDFTL/${IdTurnoCaja}`);
            const data = await response.json();
            this.setState({
                dataPdf: data
            })
            await this.obtenerMovimientos(IdTurnoCaja)
        } catch (error) {
            this.setState({loading: false, error: error})
        }
    }

    getMontosEntradasSalidas = () => {
        let sumEntTemp = 0;
        let sumSalTemp = 0;
        const movCajas = this.state.data.movCajas || []
        movCajas.map((obj) => {
            if (obj.Tipo == "Entrada") {
                sumEntTemp = sumEntTemp + obj.Monto

            } else if (obj.Tipo == "Salida") {
                sumSalTemp = sumSalTemp + obj.Monto
            }
        })

        this.setState({
            MontoEntradas: sumEntTemp,
            MontoSalidas: sumSalTemp
        })
    }

    async calcularTotales() {
        const movCajas = this.state.data.movCajas || []
        let [entradas, salidas, salidasComprobante, salidasNormales] = calcularMovsCaja(movCajas);
        
        // Calculate totals for each payment method
        let [totalOkVisa, totalBadVisa] = await this.calcularTotalVisa();
        let [totalOkAmerican, totalBadAmerican] = await this.calcularTotalAmerican();
        let [totalOkOtros, totalBadOtros] = await this.calcularTotalOtros();
        let [totalOkYape, totalBadYape] = await this.calcularTotalYape();
        let [totalOkTunki, totalBadTunki] = await this.calcularTotalTunki();
        let [totalOkRappi, totalBadRappi] = await this.calcularTotalRappi();
        let [totalOkPlin, totalBadPlin] = await this.calcularTotalPlin();
        let [totalOkMaster, totalBadMaster] = await this.calcularTotalMaster();
        let [totalOkFpay, totalBadFpay, totalFpayCancel] = await this.calcularTotalFpay();
        let [totalOkCredito, totalBadCredito] = await this.calcularCreditos();

        let totalAnuladosTarjetas = 0;
        let [totalEfectivoVentas, totalEfectOk, totalEfectBad] = await this.calularTotalEfectivo(
            totalAnuladosTarjetas,
            entradas,
            salidasNormales,
        );

        let redondeoOk = await getTotalRedondeo(
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        let redondeoBad = await getTotalRedondeo(
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );

        const ignoreInitialAmount = "ignoreInitialAmount" in this.state.configuration
            ? this.state.configuration.ignoreInitialAmount
            : false;

        this.setState({
            MontoFinalEfectivoSistema: Number(
                decimalAdjust(
                    "floor",
                    ignoreInitialAmount
                        ? totalEfectivoVentas
                        : totalEfectivoVentas + +this.props.montoInicial,
                    -2,
                ),
            ),
            MontoFinalEfectivoSistemaTemp: Number(
                decimalAdjust(
                    "floor",
                    ignoreInitialAmount
                        ? totalEfectivoVentas
                        : totalEfectivoVentas + +this.props.montoInicial,
                    -2,
                ),
            ),
            MontoFinalTarjetaMasterCardSistema: Number(
                decimalAdjust("floor", totalOkMaster - totalBadMaster, -2),
            ),
            MontoFinalTarjetaVisaSistema: Number(
                decimalAdjust("floor", totalOkVisa - totalBadVisa, -2),
            ),
            MontoFinalTarjetaAmericanSistema: Number(
                decimalAdjust("floor", totalOkAmerican - totalBadAmerican, -2),
            ),
            MontoFinalOtraTarjetaSistema: Number(
                decimalAdjust("floor", totalOkOtros - totalBadOtros, -2),
            ),
            MontoFinalCreditoSistema: Number(
                decimalAdjust("floor", totalOkCredito - totalBadCredito, -2),
            ),
            MontoFinalFpaySistema: Number(decimalAdjust("floor", totalOkFpay, -2)),
            MontoFinalYapeSistema: Number(
                decimalAdjust("floor", totalOkYape - totalBadYape, -2),
            ),
            MontoFinalTunkiSistema: Number(
                decimalAdjust("floor", totalOkTunki - totalBadTunki, -2),
            ),
            MontoFinalRappiSistema: Number(
                decimalAdjust("floor", totalOkRappi - totalBadRappi, -2),
            ),
            MontoFinalPlinSistema: Number(
                decimalAdjust("floor", totalOkPlin - totalBadPlin, -2),
            ),
            Saldo: Number(decimalAdjust("floor", totalEfectivoVentas, -2)),
            redondeoRVAceptados: redondeoOk,
            redondeoRVAnulados: redondeoBad,
            totales: {
                entradas: decimalAdjust("floor", entradas, -2),
                salidas: decimalAdjust("floor", salidas, -2),
                totalOkMaster: decimalAdjust("floor", totalOkMaster, -2),
                totalBadMaster: decimalAdjust("floor", totalBadMaster, -2),
                totalOkVisa: decimalAdjust("floor", totalOkVisa, -2),
                totalBadVisa: decimalAdjust("floor", totalBadVisa, -2),
                totalOkAmerican: decimalAdjust("floor", totalOkAmerican, -2),
                totalBadAmerican: decimalAdjust("floor", totalBadAmerican, -2),
                totalOkOtros: decimalAdjust("floor", totalOkOtros, -2),
                totalBadOtros: decimalAdjust("floor", totalBadOtros, -2),
                totalOkCredito: decimalAdjust("floor", totalOkCredito, -2),
                totalBadCredito: decimalAdjust("floor", totalBadCredito, -2),
                totalOkFpay: decimalAdjust("floor", totalOkFpay, -2),
                totalBadFpay: decimalAdjust("floor", totalBadFpay, -2),
                totalOkYape: decimalAdjust("floor", totalOkYape, -2),
                totalBadYape: decimalAdjust("floor", totalBadYape, -2),
                totalOkTunki: decimalAdjust("floor", totalOkTunki, -2),
                totalBadTunki: decimalAdjust("floor", totalBadTunki, -2),
                totalOkRappi: decimalAdjust("floor", totalOkRappi, -2),
                totalBadRappi: decimalAdjust("floor", totalBadRappi, -2),
                totalOkPlin: decimalAdjust("floor", totalOkPlin, -2),
                totalBadPlin: decimalAdjust("floor", totalBadPlin, -2),
                totalCancelFpay: decimalAdjust("floor", totalFpayCancel, -2),
                totalEfectOk: decimalAdjust("floor", totalEfectOk, -2),
                totalEfectBad: decimalAdjust("floor", totalEfectBad, -2),
                salidasComprobante: salidasComprobante,
                salidasNormales: salidasNormales,
            },
        });
    }

    async calcularTotalVisa() {
        const totalOk = await this.getTotalByComprobante(
            POS,
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        const totalBad = await this.getTotalByComprobante(
            POS,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [totalOk, totalBad];
    }

    async calcularTotalAmerican() {
        const totalOk = await this.getTotalByComprobante(
            AMERICAN,
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        const totalBad = await this.getTotalByComprobante(
            AMERICAN,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [totalOk, totalBad];
    }

    async calcularTotalOtros() {
        const totalOk = await this.getTotalByComprobante(
            OTROS,
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        const totalBad = await this.getTotalByComprobante(
            OTROS,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [totalOk, totalBad];
    }

    async calcularTotalYape() {
        const totalOk = await this.getTotalByComprobante(
            YAPE,
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        const totalBad = await this.getTotalByComprobante(
            YAPE,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [totalOk, totalBad];
    }

    async calcularTotalTunki() {
        const totalOk = await this.getTotalByComprobante(
            TUNKI,
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        const totalBad = await this.getTotalByComprobante(
            TUNKI,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [totalOk, totalBad];
    }

    async calcularTotalRappi() {
        const totalOk = await this.getTotalByComprobante(
            RAPPI,
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        const totalBad = await this.getTotalByComprobante(
            RAPPI,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [totalOk, totalBad];
    }

    async calcularTotalPlin() {
        const totalOk = await this.getTotalByComprobante(
            PLIN,
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        const totalBad = await this.getTotalByComprobante(
            PLIN,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [totalOk, totalBad];
    }

    async calcularTotalMaster() {
        const totalOk = await this.getTotalByComprobante(
            MASTER,
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        const totalBad = await this.getTotalByComprobante(
            MASTER,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [totalOk, totalBad];
    }

    async calcularTotalFpay() {
        const totalOk = await this.getTotalByComprobante(
            FPAY,
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        const totalBad = await this.getTotalByComprobante(
            FPAY,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        const totalCancel = await this.getTotalByComprobante(
            FPAY,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [totalOk, totalBad, totalCancel];
    }

    async calcularCreditos() {
        const totalOk = await this.getTotalByComprobante(
            PAGO_CREDITO,
            `${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.PENDIENTE}`,
        );
        const totalBad = await this.getTotalByComprobante(
            PAGO_CREDITO,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [totalOk, totalBad];
    }

    async calularTotalEfectivo(anuladosTarjetas, totalIngresos, salidasNormales) {
        const totalEfectOk = await this.getTotalByComprobante(
            EFECTIVO,
            `${ESTADO_CE.ACEPTADO},${ESTADO_CE.PENDIENTE},${ESTADO_VENTA.PROCESADA},${ESTADO_CE.RECHAZADO},${ESTADO_CE.NINGUNO}`,
            `${ESTADO_VALE.PENDIENTE},${ESTADO_VALE.ANULADO},${ESTADO_VALE.PROCESADO}`,
        );
        const totalEfectBad = await this.getTotalByComprobante(
            EFECTIVO,
            `${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`,
            `${ESTADO_VALE.ANULADO}`,
        );
        return [
            totalEfectOk -
                totalEfectBad +
                totalIngresos -
                salidasNormales -
                anuladosTarjetas,
            totalEfectOk,
            totalEfectBad,
        ];
    }

    async getTotalByComprobante(idTipoPago, estadoVenta, estadoVale) {
        let queryParams = `idsTipoPago=${idTipoPago}&
                idTurnoCaja=${this.state.IdTurnoCaja}&
                estadoVenta=${estadoVenta}&
                estadoVale=${estadoVale}
                `.replace(/\s/g, "");
        let response = await fetch(`/api/turnos/total-ventas?${queryParams}`);
        let resJson = await response.json();
        return Number(resJson.total);
    }

    async getConfiguration() {
        try {
          const req = await fetch(`/api/config/emp`);
          const res = await req.json();
          this.setState({ configuration: { ...res } });
        } catch (e) {
          console.error(e);
        }
    }

    async fetchMontosCaja() {
        const response = await fetch(`/api/cajas/`);
        const data = await response.json();
        return (data.movCajas || [])
    }

    printItem = async (item) => {
        this.setState({
            IdTurnoCaja: item.IdTurnoCaja,
        })

        await new Promise(resolve => setTimeout(resolve, 1000));

        await this.TraerInfoPDF(item.IdTurnoCaja);

        await this.calcularTotales();

        const payload = {
            ...item,
            IdTurnoCaja: item.IdTurnoCaja,
            redondeoRVAceptados: await getTotalRedondeo(`${ESTADO_CE.ACEPTADO},${ESTADO_VENTA.PROCESADA}`, `${ESTADO_VALE.PENDIENTE}`),
            redondeoRVAnulados: await getTotalRedondeo(`${ESTADO_CE.ANULADO},${ESTADO_VENTA.PROCESADA}`, `${ESTADO_VALE.ANULADO}`),
            extImg: this.state.extImg,
            movCajas: await this.fetchMontosCaja(),
            idTurno: item.IdTurnoCaja,
            totales: this.state.totales,
            configuration: this.state.configuration,
        }

        Object.keys(payload).forEach(k => {
            if (!isNaN(+payload[k])) {
                payload[k] = Number(payload[k])
            }
            else if (typeof payload[k] === 'object') {
                Object.keys(payload[k]).forEach(k2 => {
                    if (!isNaN(+payload[k][k2])) {
                        payload[k][k2] = Number(payload[k][k2])
                    } else {
                        payload[k][k2] = payload[k][k2]
                    }
                })
            }
            else {
                payload[k] = payload[k]
            }
        })

        await handleSavePDF(payload);
    }


    render() {
        if (this.state.loading === false) {
            return <PageLoading/>;
        }
        return (

            <React.Fragment>
                <div id="productosContainer">
                    <div className="container">
                        <div className="row mb-3 mt-5">
                            <ReactTable
                                data={this.state.dataturnosSucursal.turnosSucursal}
                                filterable
                                defaultFilterMethod={(filter, row) =>
                                    String(row[filter.id]) === filter.value}
                                columns={[
                                    {
                                        columns: [
                                            {
                                                Header: "Acciones",
                                                accessor: "Editar",
                                                width: 150,
                                                filterable: false,
                                                Cell: (f) => {
                                                    return (
                                                        <React.Fragment>
                                                            <div align="center">
                                                                <BotonPDFpequeno
                                                                    // to={"/almacenes/edit/" + f.original.IdAlmacen}
                                                                    title="Guardar PDF"
                                                                    onClick={() => this.printItem(f.original)}
                                                                    className="mr-2"
                                                                />
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                },
                                            },
                                            {
                                                Header: "Usuario - Empleado",
                                                id: "Usuario",
                                                width: 300,
                                                accessor: d => d.Usuario,
                                                filterMethod: (filter, rows) =>
                                                    matchSorter(rows, filter.value, {keys: ["Usuario"]}),
                                                filterAll: true
                                            },
                                            {
                                                Header: "Caja",
                                                id: "Nombre",
                                                width: 200,
                                                accessor: d => d.Nombre,
                                                filterMethod: (filter, rows) =>
                                                    matchSorter(rows, filter.value, {keys: ["Nombre"]}),
                                                filterAll: true
                                            },
                                            {
                                                Header: "Inicio",
                                                id: "FechaInicio",
                                                width: 200,
                                                accessor: d => d.FechaInicio,
                                                filterMethod: (filter, rows) =>
                                                    matchSorter(rows, filter.value, {keys: ["FechaInicio"]}),
                                                filterAll: true
                                            },
                                            {
                                                Header: "Cierre",
                                                id: "FechaFin",
                                                width: 200,
                                                accessor: d => d.FechaFin,
                                                filterMethod: (filter, rows) =>
                                                    matchSorter(rows, filter.value, {keys: ["FechaFin"]}),
                                                filterAll: true
                                            },
                                        ]
                                    },
                                ]}
                                defaultPageSize={5}
                                //pageSize={10}
                                className="-striped -highlight"
                                // Text de paginación
                                previousText='Anterior'
                                nextText='Siguiente'
                                loadingText='Cargando...'
                                noDataText='No se encontraron registros'
                                pageText='Página'
                                ofText='de'
                                rowsText='filas'
                                pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default turnosDetalleList;
